import { Assets } from "pixi.js";
import type { AssetManifest } from "./AssetManifest";

export class AssetLoader {
  private initialized = false;
  private loadedBundles = new Set<string>();

  async init(manifest: AssetManifest): Promise<void> {
    if (this.initialized) return;
    await Assets.init({ manifest });
    this.initialized = true;
  }

  async loadBundle(name: string): Promise<Record<string, unknown>> {
    const result = (await Assets.loadBundle(name)) as Record<string, unknown>;
    this.loadedBundles.add(name);
    return result;
  }

  async load<T = unknown>(alias: string): Promise<T> {
    return Assets.load<T>(alias);
  }

  async unloadBundle(name: string): Promise<void> {
    if (!this.loadedBundles.has(name)) return;
    await Assets.unloadBundle(name);
    this.loadedBundles.delete(name);
  }

  isLoaded(alias: string): boolean {
    return Object.hasOwn(Assets.cache, alias);
  }
}
